import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createCategory,
  deleteCategory,
  getAllCategories,
  getCategoriesWithConsentForms,
  updateCategory,
  uploadCategoryConsentDocument,
} from "./categories.service";

const key = "jeep-rally-categories";

export const useGetAllCategories = () => {
  return useQuery({
    queryKey: [key],
    queryFn: getAllCategories,
  });
};

export const useGetCategoriesWithConsentForms = (options = {}) => {
  return useQuery({
    queryKey: [key, "consent-forms"],
    queryFn: getCategoriesWithConsentForms,
    ...options,
  });
};

export const useCreateCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useUpdateCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ categoryId, payload }) =>
      updateCategory(categoryId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useUploadCategoryConsentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ categoryId, file }) =>
      uploadCategoryConsentDocument(categoryId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useDeleteCategoryMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};
